import find from 'lodash/find'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import Options from './Options'

const VariantSelector = ({ id, setSelectedVariant }) => {
  const lineItem = useSelector(state => state.lineItems.items[id])
  const { variant, variantOptions } = lineItem
  const isEditingAllowed = variantOptions.length > 1

  const handleOnChange = value => {
    const variant = find(variantOptions, { 'id': parseInt(value) })

    setSelectedVariant(variant)
  }

  return (
    <If condition={isEditingAllowed}>
      <div className='d-flex flex-column align-items-baseline mb-2 u-gap-half'>
        <label className='u-weight--medium' htmlFor='variant-select'>
          <FormattedMessage id='common.duration' />
        </label>
        <select
          defaultValue={variant.id.toString()}
          id='variant-select'
          onChange={event => handleOnChange(event.target.value)}
        >
          <Options {...{
            id,
            variantOptions
          }}
          />
        </select>
      </div>
    </If>
  )
}

export default VariantSelector

VariantSelector.propTypes = {
  id: PropTypes.number.isRequired,
  setSelectedVariant: PropTypes.func.isRequired
}
